import { createFileRoute } from "@tanstack/react-router"
import { procedureInitiativesViewStaticData } from "src/views/ProcedureInitiativesView/constants"
import { ProcedureInitiativesView } from "src/views/ProcedureInitiativesView/ProcedureInitiativesView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/initiatives/")({
	component: ProcedureInitiativesView,
	staticData: procedureInitiativesViewStaticData,
})
